import { store } from "@store";
import { getIsAgencyManagerActiveData } from "app/redux/features/isAgencyActive";

export function buildQueryParamWithAgencyManager(baseQueryParam: string = ""): string {
  const state = store.getState();
  const { isAgencyManagerActive } = getIsAgencyManagerActiveData(state);

  const params = new URLSearchParams();

  // Add base query param if it exists
  if (baseQueryParam) {
    const baseParts = baseQueryParam.split("&");
    baseParts.forEach((part) => {
      const [key, value] = part.split("=");
      if (key) {
        params.append(decodeURIComponent(key), value ? decodeURIComponent(value) : "");
      }
    });
  }

  // Add isAgencyManager param
  if (isAgencyManagerActive) {
    params.set("isAgencyManager", "true");
  }

  const result = params.toString();
  return result ? `?${result}` : "";
}

export function appendAgencyManagerParam(baseQueryParam: string = ""): string {
  const state = store.getState();
  const { isAgencyManagerActive } = getIsAgencyManagerActiveData(state);

  if (!isAgencyManagerActive) {
    return baseQueryParam;
  }

  if (!baseQueryParam) {
    return "isAgencyManager=true";
  }

  // Check if query param already has a ? at the start
  if (baseQueryParam.startsWith("?")) {
    return `${baseQueryParam}&isAgencyManager=true`;
  }

  // Check if param already contains isAgencyManager
  if (baseQueryParam.includes("isAgencyManager")) {
    return baseQueryParam;
  }

  return `${baseQueryParam}&isAgencyManager=true`;
}
